import React from 'react';
import { motion } from 'framer-motion';
import RobotIcon from './RobotIcon';

const TypingIndicator = () => (
  <motion.div
    className="chat-bubble-row from-other"
    initial={{ opacity: 1 }}
    animate={{ opacity: 1 }}
  >
    <div className="chat-bubble-wrapper">
      <div className="chat-avatar bot">
        <RobotIcon size={24} />
      </div>
      <div className="chat-bubble from-other">
        <div className="typing-indicator">
          <span className="typing-dot" />
          <span className="typing-dot" />
          <span className="typing-dot" />
        </div>
      </div>
    </div>
  </motion.div>
);

export default TypingIndicator;
